import React, { useEffect, useState, useLayoutEffect } from "react"
import cookie from "react-cookies"
import { Layout, PageHeader, Result } from 'antd';
import menuConfig from "../../config/menuConfig"
import { Route, Redirect, Switch, useHistory, Link } from 'react-router-dom'
import Header from '../../components/header/header'
import LeftNav from '../../components/left-nav/left-nav'
import Home from '../home'
import Logs from '../logs'
import Company from '../company'
import Account from "../account";
import Group from '../group'
import Card from '../card'
import System from '../system'
import { reqGetCompanyList, reqGetCompanyRights, reqGetCompany, reqGetGroup } from "../../api"
import store from "../../utils/storeUtils"
import { message } from "antd";
import memory from "../../utils/memoryUtils"
import logo from "../../assets/images/logo.png"
import SITE from "../../config/siteConfig"
import "./admin.css"
import { connect } from "react-redux"
import { update_companies, update_groups } from "../../redux/actions"
const { Footer, Sider, Content } = Layout;

class Admin extends React.Component {
    state = {
        companyLoadingCompleted: false,
        rightsLoadingCompleted: false,
        collapsed: false,
        isLogin: false
    }

    UNSAFE_componentWillMount() {
        this.checkOn()

    }
    componentDidMount() {

        if (this.state.isLogin) {
            this.saveRightsList()
            //  this.saveCompanyInfo()
            this.getCompanyList()
            this.getGroups()
            this.checkDevices()
        }

    }
    //获取选择群组列表
    getGroups = async () => {
        const res = await reqGetGroup()
        if (res.code === 200) {
            this.props.update_groups(res.data.group_list)
        }
    }
    //获取选择公司列表
    getCompanyList = async () => {
        const res = await reqGetCompany()
        if (res.code === 200) {
            const currentCompany = res.data.company_info
            const subCompanys = res.data.subcompany_list
            this.props.update_companies([currentCompany, subCompanys])
        }
    }
    //检测是否登陆
    checkOn = () => {
        if (!cookie.load(".SCAUTH")) {
            this.props.history.replace("/login")
            return
        } else {
            this.setState({
                isLogin: true
            })
        }

    }
    //#region 终端检测
    //     const[companyLoadingCompleted, setCompanyLoadingCompleted] = useState(false)
    //     const[rightsLoadingCompleted, setRightsLoadingCompleted] = useState(false)
    //     const[collapsed, setCollapsed] = useState(false)
    //     const history = useHistory()
    //     const path = history.location.pathname;
    //     //判断cookie如果不存在 跳转到登陆界面
    //     if(!cookie.load(".SCAUTH")) {
    //     history.replace("/login")
    // }
    // var system = {
    //     win: false,
    //     mac: false,
    //     xll: false,
    //     ipad: false
    // };
    //检测平台 
    // var p = navigator.platform;
    // system.win = p.indexOf("Win") === 0;
    // system.mac = p.indexOf("Mac") === 0;
    // system.x11 = (p === "X11") || (p.indexOf("Linux") === 0);
    // system.ipad = (navigator.userAgent.match(/iPad/i) != null) ? true : false;
    // //跳转语句，如果是手机访问就自动跳转到wap.baidu.com页面 

    // if (system.win || system.mac || system.xll || system.ipad) {
    // } else {
    //     alert("请用电脑端访问站点,获得最佳视图")
    // }
    //把权限列表存起来方便后面使用
    //#endregion
    checkDevices() {
        var system = {
            win: false,
            mac: false,
            xll: false,
            ipad: false
        };
        var p = navigator.platform;
        system.win = p.indexOf("Win") === 0;
        system.mac = p.indexOf("Mac") === 0;
        system.x11 = (p === "X11") || (p.indexOf("Linux") === 0);
        system.ipad = (navigator.userAgent.match(/iPad/i) != null) ? true : false;
        //跳转语句，如果是手机访问就自动跳转到wap.baidu.com页面 

        if (system.win || system.mac || system.xll || system.ipad) {
        } else {
            alert("请用电脑端访问站点,获得最佳视图")
        }
    }
    saveRightsList = async () => {
        const res = await reqGetCompanyRights()
        if (res.code === 200) {
            store.saveCompanyInfo({ rights: res.data.list })
            this.setState({
                rightsLoadingCompleted: true
            })
        } else {
            console.log("未登录")
        }
    }
    //先把公司信息存起来 方便后面使用
    // saveCompanyInfo = async () => {
    //     const res = await reqGetCompanyList()
    //     if (res.code === 200) {
    //         store.saveCompanyInfo(res.data.company_info)
    //         this.setState({
    //             companyLoadingCompleted: true
    //         })
    //     } else {
    //         console.log("未登录")
    //     }
    // }
    onCollapse = collapsed => {
        this.setState({
            collapsed
        })
    };
    //#region  获取当前菜单title
    // getTitle = (path, menuItem) => {
    //     for (let index = 0; index < menuItem.length; index++) {
    //         const element = menuItem[index];
    //         if (!element.children) {
    //             if (element.key === path) {
    //                 return element.title
    //             }
    //         } else {
    //             if (this.getTitle(path, element.children)) {
    //                 return this.getTitle(path, element.children)
    //             } else {
    //                 continue
    //             }
    //         }
    //     }
    // }
    // getMenuTitle = (path, menuItem) => {
    //     const routes = []
    //     try {
    //         if (path === "/home") {
    //             routes.push({
    //                 path: 'index',
    //                 breadcrumbName: '首页',
    //             })
    //         } else {
    //             var reg1 = /(\/[a-z]+)/
    //             var reg2 = /(\/[a-z]+){2}/
    //             debugger
    //             var result1 = reg1.exec(path)[0]
    //             var result2 = reg2.exec(path)[0]
    //             for (let index = 0; index < menuItem.length; index++) {
    //                 const element = menuItem[index];
    //                 if (element.key === result1) {
    //                     routes.push({
    //                         path: element.key,
    //                         breadcrumbName: element.title,
    //                     })
    //                 }
    //                 if (!element.children) {
    //                     continue
    //                 }
    //                 for (let i = 0; i < element.children.length; i++) {
    //                     const el = element.children[i];
    //                     if (el.key === result2) {
    //                         routes.push({
    //                             path: el.key,
    //                             breadcrumbName: el.title,
    //                         })
    //                     }
    //                 }
    //             }


    //         }
    //     } catch (error) {

    //     }

    //     return { routes }
    // }
    //#endregion
    render() {
        const { collapsed, isLogin } = this.state
        const { onCollapse, getTitle } = this
        return (
            isLogin ? (
                <Layout className="layout-w">
                    <Sider className="sider"
                        // collapsible
                        collapsed={collapsed}
                        onCollapse={onCollapse}>
                        <Link to="/">
                            <div className="logo">
                                <img src={logo} alt="" />
                                <h1 >{SITE.TITLE}</h1>
                            </div>
                        </Link>
                        <LeftNav></LeftNav>
                    </Sider>
                    <Layout className="layout-n">
                        <Header></Header>
                        {/* <div className="site-page-header-ghost-wrapper">
                <PageHeader
                    className="site-page-header"
                    // breadcrumb={getMenuTitle(path, menuConfig)}
                    title={getTitle(path, menuConfig)}
                />
            </div> */}
                        <Content className="content">
                            <Switch>
                                <Route path="/home" component={Home}></Route>
                                <Route path="/company" component={Company}></Route>
                                <Route path="/account" component={Account}></Route>
                                <Route path="/group" component={Group}></Route>
                                <Route path="/card" component={Card}></Route>
                                <Route path="/system" component={System}></Route>
                                <Route path="/logs" component={Logs}></Route>
                                <Redirect to="/home"></Redirect>
                            </Switch>
                        </Content>
                        <Footer className="footer">{`Powered By Copyright Owners ${SITE.VERSION}`}</Footer>
                    </Layout>
                </Layout>
            ) : null
        )
    }

}

export default connect(
    null,
    { update_companies, update_groups }
)(Admin)